import { Component, Input, OnInit } from '@angular/core';
import { BookingEditorCommercialRowModel } from '../../../services/booking-editor/booking-editor.model';
import { BookingEditorService } from '../../../services/booking-editor/booking-editor.service';

@Component({
  selector: 'sb-commercial-row',
  templateUrl: './sb-commercial-row.component.html',
  styleUrls: ['./sb-commercial-row.component.scss'],
  standalone: false,
})
export class SbCommercialRowComponent implements OnInit {
  commercialRow: BookingEditorCommercialRowModel | any;
  // tslint:disable-next-line:variable-name
  _commercialRowId: number;
  @Input() set commercialRowId(value: string) {
    this._commercialRowId = value ? Number(value) : null;
  }

  @Input() countEvents;

  constructor(public bookingEditor: BookingEditorService) {}

  ngOnInit(): void {
    this.commercialRow = this.bookingEditor.resourceStore.getById(this._commercialRowId);
  }
}
